import { Component, OnInit } from '@angular/core';
// import { ContactUsComponent } from '../../share-module/contact-us/contact-us.component';
import { from } from 'rxjs';
import { type } from 'os';
import { LayoutService } from 'src/app/share-module/layout.service';

@Component({
  selector: 'app-guest-contact-us',
  templateUrl: './guest-contact-us.component.html',
  styleUrls: ['./guest-contact-us.component.css']
})
export class GuestContactUsComponent implements OnInit {

  GNtype: string = '';
  constructor(private layoutService:LayoutService) {
    this.layoutService.setShowSidebar(false);
    this.GNtype = "GN"
  }

  ngOnInit() {

  }

}

